import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-add-icon',
  templateUrl: 'add-icon.component.html'
})
export class AddIconComponent {
  constructor() {}
}
